import React from "react"
import PropTypes from "prop-types"

import AirlineForm from "apps/airlines/Airline/AirlineForm"
import { reverse } from "utils/urls"

export default function AirlineUpdate(props) {
  return (
    <AirlineForm
      {...props}
      isUpdate
      actionEndpoint={`/airlines/${props.match.params.id}/`}
      successUrl={reverse("airlineDetail", { id: props.match.params.id })}
    />
  )
}

AirlineUpdate.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.exact({
      id: PropTypes.string.isRequired,
    }),
  }).isRequired,
}
